// NPM Imports
import React from "react";
import PropTypes from "prop-types";

// CSS Imports
import style from "./revvLoader.module.scss";

const Loader = props => {
  const { className, fullScreen, label, theme } = props;
  return (
    <div
      className={`${style.container} ${fullScreen ? style.fullScreen : ""} ${
        theme === "light" ? style.lightBg : style.darkBg
      } ${className} `}>
      <div className={`${style.loader}`}>
        <span />
      </div>
      <span
        className={`${style.label} ${
          theme === "light" ? style.darkLabel : style.lightLabel
        }`}>
        {label || null}
      </span>
    </div>
  );
};

Loader.defaultProps = {
  className: "",
  fullScreen: false,
  label: "",
  theme: "light",
};

Loader.propTypes = {
  className: PropTypes.string,
  fullScreen: PropTypes.bool,
  label: PropTypes.string,
  theme: PropTypes.string,
};

export default Loader;
